import React, { useEffect } from "react";
import { FormControl, Select, MenuItem, Typography } from "@mui/material";
import { generateClient } from "aws-amplify/api";
import { listCategories } from "../../graphql/queries";
import { useDispatch, useSelector } from "react-redux";
import {
  setCategories,
  setContentType,
} from "../../redux/slices/contentSlice/contentForm/contentForm";
import { setLoading } from "../../redux/slices/contentSlice/contentForm/contentForm";
import { WATCH, LISTEN, READ, DEVOTION, PLAY } from "../../constants";

const ContentType = ({ formik }) => {
  const client = generateClient();
  const dispatch = useDispatch();

  // Fetch Category According To Content Type
  const fetchCategoriesByContentType = async (contentType) => {
    try {
      dispatch(setLoading(true));
      const response = await client.graphql({
        query: listCategories,
        variables: {
          filter: {
            type: {
              eq: contentType,
            },
          },
        },
      });
      const categoryList = response.data.listCategories.items;
      
      // Don't sort here - we'll handle specific ordering in the Category component
      dispatch(setCategories(categoryList));
      return categoryList;
    } catch (error) {
      console.error("Error fetching category:", error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleContentType = async (e) => {
    const contentType = e.target.value;
    formik.setFieldValue("type", contentType);
    dispatch(setContentType(contentType));
    await fetchCategoriesByContentType(contentType);
  };

  // Specific order for content types based on requirements
  // Here we use an array to maintain the order, not sorting
  const contentTypeOptions = [
    { value: WATCH, label: "Watch" },
    { value: LISTEN, label: "Listen" },
    { value: READ, label: "Read" },
    { value: DEVOTION, label: "Devotional" },
    { value: PLAY, label: "Play" }
  ];

  return (
    <>
      <FormControl fullWidth>
        <label style={{ margin: "10px 0" }} htmlFor="content-type">
          Content Type
          <span style={{ color: "red", marginLeft: "5px" }}>*</span>
        </label>
        <Select
          name="type"
          id="content-type"
          style={{ color: formik.values.type === "" ? "lightgrey" : "inherit" }}
          value={formik.values.type}
          onChange={handleContentType}
        >
          <MenuItem disabled value="">
            <em>Select Content Type</em>
          </MenuItem>
          {contentTypeOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {formik.touched.type && formik.errors.type && (
        <Typography sx={{ color: "red" }}>{formik.errors.type}</Typography>
      )}
    </>
  );
};

export default ContentType;